import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemIngressForm,
  mountForm,
  unmountForm,
  showToast,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import { restartResourcesToastDefinition } from './SystemSetupTrustedCertificatesNew';

const formKey = 'system-setup-ingress';

regRoute('SYSTEM_INGRESS_PAGE', '/system/setup/infra/ingress');

regSaga(
  takeEvery('ENTER_SYSTEM_INGRESS_PAGE', function*() {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_INGRESS_PAGE', function*() {
    yield call(unmountForm, formKey);
  }),
);

const handleSave = () => () => {
  unmountForm(formKey);
  mountForm(formKey);
  showToast(restartResourcesToastDefinition);
};

const FormLayout = ({ fields, error, buttons, bindings: { values } }) => (
  <form>
    <div className="heading heading-sm">
      <h2 className="h3">Ingress Settings</h2>
    </div>
    <div className="form-group--toggle">
      {!values.get('change_key')
        ? fields.get('current_key')
        : fields.get('key')}
      {fields.get('change_key')}
    </div>
    {!values.get('change_certificate') ? (
      <div className="form-group--toggle">
        {fields.get('current_certificate')}
        {fields.get('change_certificate')}
      </div>
    ) : (
      <fieldset>
        <div className="row">
          <div className="col-xxl-6 mb-4">{fields.get('certificate')}</div>
          <div className="col-xxl-6 mb-4">{fields.get('ca-chain')}</div>
          <div className="col">{fields.get('change_certificate')}</div>
        </div>
      </fieldset>
    )}
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupIngress = () => {
  return (
    <div className="content-container">
      <SystemIngressForm
        formKey={formKey}
        onSave={handleSave}
        components={{
          FormError,
          FormButtons: generateFormButtons({
            submitLabel: 'Update Ingress Settings',
            cancelPath: '/system/setup/config',
          }),
          FormLayout,
        }}
        alterFields={{
          current_certificate: {
            renderAttributes: {
              modalTitle: 'Ingress Certificate Details',
              filename: `ingress_certificate_with_chain.crt`,
            },
          },
        }}
      >
        {({ form }) => form}
      </SystemIngressForm>
    </div>
  );
};
